
//AsFeatured in Slider
$('.as-featured-in').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 9000,
    pauseOnHover: false,
    infinite: true,
    loop: true,
    cssEase: 'linear',
    arrows: false,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 780,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});

$('.testimonial-wrapper').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  infinite: true,
  pauseOnHover: false,
  speed: 8500,
  arrows: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3 
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 3 
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2.5 
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1 
      }
    }
  ]
});

$('.instagram-img-wrapper').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    infinite: true,
    pauseOnHover: false,
    speed: 8500,
    arrows: false,
    cssEase: 'linear',
    responsive: [
       {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3.5
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3 
        }
      },
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 2 
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1
        }
      }
    ]
  });

$(document).ready(function(){
  function initializeSlick() {
    $('.find-us-logo-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 8000,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      infinite: true,
      pauseOnHover: false,
      cssEase: 'linear',
      swipe: true,
      responsive: [
        {
          breakpoint: 992, 
          settings: {
            slidesToShow: 2, 
            autoplay: true,
            autoplaySpeed: 0,
            infinite: true,
            speed: 8000,
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1.5,
            autoplay: true,
            autoplaySpeed: 0,
            infinite: true,
            speed: 8500,
          }
        }
      ]
    });
  }
  
  initializeSlick();
});




$(document).ready(function(){
  $('.collection-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 2, 
          slidesToScroll: 1,
          autoplay: true,
          swipe: true,
          arrows: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          swipe: true,
          arrows: true
        }
      }
    ] 
  });
});
